import {
  titleUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { claimantRelationshipOptions } from '../../utils/labels';
import content from '../../../../utils/content.json';
import ClaimantRelationshipRadioField from '../../../../config/chapters/02-claimant-information/ClaimantRelationshipRadioField';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['claimant-relationship-title']),
    claimantRelationship: {
      ...radioUI({
        title: content['claimant-relationship-question'],
        labels: claimantRelationshipOptions,
        errorMessages: {
          required: content['claimant-relationship-error'],
        },
      }),
      'ui:webComponentField': ClaimantRelationshipRadioField,
    },
  },
  schema: {
    type: 'object',
    required: ['claimantRelationship'],
    properties: {
      claimantRelationship: radioSchema(
        Object.keys(claimantRelationshipOptions),
      ),
    },
  },
};
